import { jsx as _jsx } from "react/jsx-runtime";

function SvgCopy() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.358 2A2.358 2.358 0 003 4.358v11.684A2.358 2.358 0 005.358 18.4h.232a1 1 0 100-2h-.232A.358.358 0 015 16.042V4.358C5 4.16 5.16 4 5.358 4h5.597c.062 0 .123.016.177.047l1.26.721a1 1 0 10.993-1.736l-1.26-.72A2.358 2.358 0 0010.955 2H5.358zM7.55 7.909c0-1.098.826-2.31 2.272-2.31h6.417c.613 0 1.203.24 1.643.667l2.693 2.616c.457.444.715 1.054.715 1.692v9.117c0 .608-.195 1.204-.635 1.653-.442.45-1.038.656-1.655.656H9.822c-.618 0-1.214-.207-1.653-.663-.435-.452-.62-1.047-.62-1.646V7.909zm2.085-.234a.363.363 0 00-.085.234V19.69c0 .196.056.255.06.259a.105.105 0 00.041.024c.028.011.082.026.171.026H19c.172 0 .221-.05.227-.057.008-.007.063-.066.063-.253V11.9h-2.901a1.479 1.479 0 01-1.48-1.479V7.6H9.823a.272.272 0 00-.116.021.214.214 0 00-.07.054zm6.875.047l2.654 2.578H16.51V7.722z"
    }, void 0)
  }), void 0);
}

export default SvgCopy;